import React from 'react'
import { Grid, Button } from '@material-ui/core'
import '../../Style/crearFormularioElegibilidad.scss'
import ExitIcon from '@material-ui/icons/ExitToApp'
import SaveIcon from '@material-ui/icons/Save'
import ReactTooltip from 'react-tooltip'
import swal from 'sweetalert'
import Swal from 'sweetalert2'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import Table41 from '../../Tables/TablesSec4/Table41'
import { useEligibility } from '../../../../../context/EligibilityContext'
import { useHistory } from 'react-router-dom'
import ROUTES from '../../../../../routers/routes'
import { useAuthentication } from '../../../../../context/authenticationContext'
import { validateEditForm } from '../../../../../services/Forms/create'
import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'

const ElegibilidadSec4Edit = (props) => {
  const { goToStep } = props
  const history = useHistory()
  const { userIDB2C } = useAuthentication()
  const { editFormElegibility } = useFormElegibilidad()

  // eslint-disable-next-line no-unused-vars
  const [, dispatch] = useEligibility()

  const EvaluationDataSchema = Yup.object().shape({
    validTable41: Yup.boolean().oneOf([true], 'Faltan campos en la tabla'),
  })

  const formik = useFormik({
    // enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      validTable41: false,
    },
    validationSchema: EvaluationDataSchema,
    onSubmit: () => {
      next()
    },
  })

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const next = () => {
    dispatch({ type: 'SET_STATE', payload: 5 })
    goToStep(5)
  }
  const previous = () => {
    dispatch({ type: 'SET_STATE', payload: 3 })
    goToStep(3)
  }

  const fakeSave = async (values, borrador, exit) => {
    swal({
      title: 'Formulario Guardado',
      icon: 'success',
      button: 'Entendido',
    })
    if (exit) {
      history.push(ROUTES.BORRADORELEGIBILIDAD.pathname)
    }
  }
  const cancelForm = () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Se perderán los datos no guardados',
      icon: 'warning',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      confirmButtonColor: '#3085d6',
      denyButtonText: `No guardar`,
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await validateEditForm(
          userIDB2C,
          2,
          editFormElegibility.IdElegibilityAnswer,
        )
        if (response.Success) {
          const exit = true
          fakeSave(formik.values, true, exit)
        }
      } else if (result.isDenied) {
        const response = await validateEditForm(
          userIDB2C,
          2,
          editFormElegibility.IdElegibilityAnswer,
        )
        if (response.Success) history.push(ROUTES.BORRADORELEGIBILIDAD.pathname)
      }
    })
  }

  return (
    <>
      <Grid
        container
        md={12}
        sm={12}
        spacing={1}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Grid item>
          <div
            data-tip
            data-for="exitPop"
            onClick={() => cancelForm()}
            style={{
              backgroundColor: 'red',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <ExitIcon style={{ transform: 'scaleX(-1)' }} />
            <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
              <span>Regresar</span>
            </ReactTooltip>
          </div>
        </Grid>
        <Grid item>
          <div
            onClick={() => fakeSave()}
            data-tip
            data-for="savePop"
            style={{
              backgroundColor: '#5cb85c',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <SaveIcon />
          </div>
          <ReactTooltip id="savePop" effect="solid" backgroundColor="#5cb85c">
            <span>Guardar Borrador</span>
          </ReactTooltip>
        </Grid>
      </Grid>
      <br></br>
      <form id="evaluation-data-form">
        <Grid item xs={12} sm={12} md={12}>
          <h1 className="h1text">GÉNERO</h1>
          <br />
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={12}>
            <label className="responsiveLabel">
              1.- Seleccione el tipo de actividades dentro de la MIPYME que son
              realizadas por mujeres y hombres (Obligatorio)
            </label>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Table41 formik={formik}></Table41>
            {formik.errors.validTable41 ? (
              <div
                style={{
                  color: 'red',
                  marginTop: '3px',
                  fontSize: '13px',
                }}
              >
                {formik.errors.validTable41}
              </div>
            ) : null}
          </Grid>

          <Grid container spacing={1} className="button__container">
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'left' }}
              className="continerButtonNav"
            >
              <Button
                onClick={() => previous()}
                variant="contained"
                className="button__wizard button__previous"
                disabled={false}
              >
                Anterior
              </Button>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'right' }}
              className="continerButtonNav"
            >
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ textAlign: 'right' }}
                >
                  <Button
                    // type="submit"
                    onClick={() => validateFormStatus()}
                    className="button__wizard button__next"
                    disabled={false}
                  >
                    Siguiente
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default ElegibilidadSec4Edit
